/**
 * Haptic Feedback Utilities
 * Provides simple haptic feedback for user interactions on mobile devices
 * Uses the Navigator.vibrate API (supported on Android and some iOS devices)
 */
export const haptics = {
    /**
     * Light vibration (10ms)
     * Use for: Button taps, minor interactions
     */
    light: () => {
        if ('vibrate' in navigator) {
            navigator.vibrate(10);
        }
    },
    /**
     * Medium vibration (20ms)
     * Use for: Starting drag, significant interactions
     */
    medium: () => {
        if ('vibrate' in navigator) {
            navigator.vibrate(20);
        }
    },
    /**
     * Heavy vibration (two pulses: 30ms, 10ms gap, 30ms)
     * Use for: Important actions, completion feedback
     */
    heavy: () => {
        if ('vibrate' in navigator) {
            navigator.vibrate([30, 10, 30]);
        }
    },
    /**
     * Success feedback (quick double pulse)
     * Use for: Task completion, confirmation
     */
    success: () => {
        if ('vibrate' in navigator) {
            navigator.vibrate([10, 50, 10]);
        }
    },
    /**
     * Error feedback (rapid multiple pulses)
     * Use for: Errors, invalid actions, warnings
     */
    error: () => {
        if ('vibrate' in navigator) {
            navigator.vibrate([50, 30, 50, 30, 50]);
        }
    },
    /**
     * Selection feedback (single medium pulse)
     * Use for: Item selection, activation
     */
    selection: () => {
        if ('vibrate' in navigator) {
            navigator.vibrate(15);
        }
    },
    /**
     * Stop any ongoing vibration
     */
    stop: () => {
        if ('vibrate' in navigator) {
            navigator.vibrate(0);
        }
    }
};
